<template>
  <main-component />
</template>

<script>
import MainComponent from '@/components/UsersNew/index'

export default {
  components: {
    MainComponent
  }
}
</script>
